import { i18n } from '@/commons/utils';

const MOVE_TO_BUY_LATER_LIST = 'rest/model/com/decathlon/cube/commerce/gifts/BuyLaterActor/moveItemsFromCart';
const MOVE_TO_CART_FROM_BUY_LATER_LIST = 'rest/model/com/decathlon/cube/commerce/gifts/BuyLaterActor/moveItemsToCart';
const REMOVE_FROM_BUY_LATER_LIST = 'rest/model/com/decathlon/cube/commerce/gifts/BuyLaterActor/removeItemFromBuyLater';
const REMOVE_BUY_LATER_LIST = 'rest/model/com/decathlon/cube/commerce/gifts/BuyLaterActor/removeItemsFromBuyLater';

const ADD_BUY_LATER_ID = '.buy-later-btn';
const ADD_TO_CART_ID = '.buy-later-to-cart-btn';
const BUY_LATER_PRODUCT_ROW = '#cartridgeDivBuyLaterId .product-item';
const BUY_LATER_NB_ITEMS = 'span.js-bll-nb-items';
const REMOVE_ITEM_FROM_BUY_LATER = 'span.js-delete-from-buy-later';
const REMOVE_ALL_ITEM_FROM_BUY_LATER = 'a.js-delete-all-from-buy-later';

let productDisplayElement;

export function init() {
  const cartRow = $('#cart-row');

  cartRow.on('click', ADD_BUY_LATER_ID, function handleClick(e) {
    e.preventDefault();
    if (!$(this).hasClass('disable')) {
      moveToBuyLaterList($(this), $(this).attr('name'), $('#gift-list-id').val());
    }
  });

  cartRow.on('click', ADD_TO_CART_ID, function handleClick(e) {
    e.preventDefault();
    moveToCartFromBuyLaterList(
      $(this),
      $(this).attr('data-catalogRefId'),
      $(this).attr('data-productId'),
      $(this).attr('data-giftlistId'),
      $(this).attr('data-giftlistItemId'),
      $(this).attr('data-modelid')
    );
  });

  cartRow.on('click', REMOVE_ITEM_FROM_BUY_LATER, function handleClick(e) {
    e.preventDefault();
    if (!$(this).hasClass('disable')) {
      removeItemFromBuyLater($(this), $(this).data('itemid'), $(this).data('giftlistid'));
    }
  });

  cartRow.on('click', REMOVE_ALL_ITEM_FROM_BUY_LATER, function handleClick(e) {
    e.preventDefault();
    removeAllItemFromBuyLater($(this));
  });

  if ($('#cart-row .buy-later').length > 0) {
    $(document).on(
      'scroll',
      cube.debounce(() => {
        if (
          $('#cartridgeDivBuyLaterId .tr:last').attr('data-nextpage') === 'true' &&
          $(window).scrollTop() >=
            $(document).height() - $(window).height() - $('#cartridgeDivBuyLaterId li:last').height()
        ) {
          reloadBuyLaterListForPagination(cartRow, $('#cartridgeDivBuyLaterId').attr('data-page'));
        }
      }, 200)
    );
  }
}

function moveToBuyLaterList($this, catalogRefId, giftlistId) {
  window
    .getAjaxHandler()
    .withCaller($this)
    .withUrl(MOVE_TO_BUY_LATER_LIST)
    .withParameter('itemIds', catalogRefId)
    .withParameter('giftlistId', giftlistId)
    .withSuccess(moveToBuyLaterListSuccess)
    .call();
}

function moveToCartFromBuyLaterList($this, catalogRefId, productId, giftlistId, giftlistItemId, modelid) {
  let analyticsAttributes = {
    ga_shoppingtool: '',
    ga_enhanced: '',
  };
  if (window.CUBE &&
      window.CUBE.Analytics &&
      window.CUBE.Analytics.utils &&
      typeof window.CUBE.Analytics.utils.getAnalyticsAttributes === 'function') {
    analyticsAttributes = window.CUBE.Analytics.utils.getAnalyticsAttributes(productId, modelid);
  }

  window
    .getAjaxHandler()
    .withCaller($this)
    .withUrl(MOVE_TO_CART_FROM_BUY_LATER_LIST)
    .withParameter('catalogRefIds', catalogRefId)
    .withParameter('productId', productId)
    .withParameter('giftlistId', giftlistId)
    .withParameter('giftlistItemId', giftlistItemId)
    .withParameter('quantity', 1)
    .withParameter('commerceItemAttributes', analyticsAttributes)
    .withSuccess(moveToCartFromBuyLaterListSuccess)
    .call();
}

function removeItemFromBuyLater($this, GiftlistItemId, giftlistId) {
  window
    .getAjaxHandler()
    .withCaller($this)
    .withUrl(REMOVE_FROM_BUY_LATER_LIST)
    .withParameter('removeGiftitemIds', GiftlistItemId)
    .withParameter('giftlistId', giftlistId)
    .withSuccess(removeItemFromBuyLaterSuccess)
    .call();
}

function removeAllItemFromBuyLater($this) {
  const giftlistId = $('a[data-giftlistid]:first').data('giftlistid');
  window
    .getAjaxHandler()
    .withCaller($this)
    .withUrl(REMOVE_BUY_LATER_LIST)
    .withParameter('giftlistId', giftlistId)
    .withSuccess(removeItemFromBuyLaterSuccess)
    .call();
}

function reloadBuyLaterListForPagination($this, currentPage) {
  const params = { currentPage: currentPage || 0 };
  window.reloadCartridgeContentCollection($this, 'cartridgeDivBuyLaterId', params);
}

function moveToBuyLaterListSuccess($this, jsonCallbackData, ajaxParameters) {
  if (window.resultHasErrors(jsonCallbackData)) {
    $.each(jsonCallbackData.responseTO.errors, (id, error) => {
      const errorMessage = JSON.stringify(error.message).replace(/"/g, '');
      window.displayError(errorMessage, window.Consts.MAIN_ERROR, null);
    });
  } else {
    productDisplayElement = getProductDisplayElement(ajaxParameters);

    const productMoved = $('.product-moved');
    if (productMoved.length > 0) {
      productMoved.parent('.faux-table-wrapper').slideUp(160, () => {
        productMoved.parent('.faux-table-wrapper').remove();
      });
    }

    productDisplayElement.parents('.faux-table-wrapper').slideUp(160, () => {
      productDisplayElement.html(
        `<h3 data-tprop="product-message" class="cart-list__product-message" ${cube.tnr.setDataTnr(
          'message-move-to-buy-later'
        )}><span class="cart-list__message-icon icon icon-ok-roll"></span>${i18n(
          'cart.cartdetails.moveFromCartToBuyLaterList'
        )}</h3>`
      );

      const productMessage = $('.cart-list__product-message');
      productMessage.parents('.faux-table').addClass('a');
      productMessage.parents('.faux-table-wrapper').slideDown(200);
    });
    window.throwEvent(window.Events.CART_ITEM_REMOVED);

    // Update the cart after a delay, to show user an item has been removed and to refresh latest prices
    // (in case a product where in a bundle promotion)
    setTimeout(() => {
      window.throwEvent(window.Events.CART_ITEM_CHANGE, {
        doNotDisplaySuccessModification: false,
        doNotRefreshSummary: true,
      });
    }, 5000);
    reloadBuyLaterListForPagination($this, $('#cartridgeDivBuyLaterId').data('page') - 1);
  }
}

function getProductDisplayElement(parameters) {
  return $(`.js-product-${parameters.itemIds}`);
}

function moveToCartFromBuyLaterListSuccess($this, result, input) {
  if (window.resultHasErrors(result)) {
    $.each(result.responseTO.errors, (id, error) => {
      const errorMessage = JSON.stringify(error.message).replace(/"/g, '');
      $this.parents('.product-item:first').addClass('unavailable-item');
      $this.parent().append(`<span class="error-item">${errorMessage}</span>`);
      $this.remove();
    });
  } else {
    productDisplayElement = getSavedProductDisplayElement(input);
    if (window.cube.config.anly_useLegacy === 'Y') {
      CUBE.Analytics.shoppingtool.sendAddToCart();
    }

    const productSavedMoved = $('.product-saved-moved');
    if (productSavedMoved.length > 0) {
      productSavedMoved.slideUp(160, () => {
        productSavedMoved.remove();
      });
    }

    productDisplayElement.slideUp(160, () => {
      productDisplayElement.html(
        `<h3 data-tprop="product-message" class="cart-list__product-message" ${cube.tnr.setDataTnr(
          'message-move-to-cart'
        )}><span class="cart-list__message-icon icon icon-ok-roll"></span>${i18n(
          'cart.cartdetails.moveToCartFromBuyLaterList'
        )}</h3>`
      );
      productDisplayElement.addClass('product-saved-moved');
      productDisplayElement.removeClass('product-item');
      productDisplayElement.slideDown(200);
    });
    window.throwEvent(window.Events.CART_ITEM_ADDED_FROM_BUY_LATER_LIST);
    updateBuyLaterListSize();
  }
}

function updateBuyLaterListSize() {
  const nbItems = $(BUY_LATER_PRODUCT_ROW).length - 1;
  $(BUY_LATER_NB_ITEMS).text(`(${nbItems} ${i18n('buylater.products')})`);
}

function getSavedProductDisplayElement(parameters) {
  return $(`.js-product-${parameters.giftlistItemId}`);
}

function removeItemFromBuyLaterSuccess($this, result) {
  if (!window.resultHasErrors(result)) {
    reloadBuyLaterListForPagination($this, $('#cartridgeDivBuyLaterId').data('page') - 1);
  } else {
    $.each(result.responseTO.errors, (id, error) => {
      const errorMessage = JSON.stringify(error.message).replace(/"/g, '');
      window.displayError(errorMessage, window.Consts.MAIN_ERROR, null);
    });
  }
}



// WEBPACK FOOTER //
// ./src/checkout/cart/buy-later-list.js